"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  'use strict';

  function paymentModalCtrl(UtilsService, PaymentService, Moment, $sce) {
    var vm = this;
    var initialState;
    var d = new Date();
    this.exampleYear = d.getFullYear() + 1;

    this.processPayment = function (form) {
      // take a copy of the payment amount as to not alter how the ui interacts with the model
      var _paymentAmount = vm.paymentAmount; // check for custom payment option, otherwise, balance due

      if (vm.paymentSelection == 2) {
        _paymentAmount = vm.totalBalanceDue;
      } else if (vm.paymentSelection == 3) {
        _paymentAmount = vm.otherAmount;
      }

      vm.processing = true;
      vm.error = '';

      if (!UtilsService.Form.isValid(form)) {
        UtilsService.Form.validateForm(form);
        vm.processing = false;

        if (form.$error && form.$error.required) {
          var billingError = form.$error.required.map(function (error) {
            return error.$name;
          }).some(function (name) {
            return name.toLowerCase().indexOf('billing') > -1;
          });

          if (billingError) {
            this.editMode = true;
          }
        }
      } else {
        PaymentService.processPayment({
          amount: _paymentAmount,
          billing: vm.billing,
          creditCard: vm.creditCard
        }, vm.admin, vm.transaction).then(function (response) {
          vm.close({
            $event: response
          });
          vm.processing = false;
        }, function (error) {
          if (typeof error === 'string') {
            vm.error = 'Error making payment. Please try again.';
          } else if (_typeof(error) === 'object' && error.hasOwnProperty('Message')) {
            var escapedError;

            if (_typeof(error) === 'object' && error.hasOwnProperty('Message')) {
              escapedError = $sce.trustAsHtml($('<div/>').html(error.Message.Message).text());
            } else {
              escapedError = $sce.trustAsHtml($('<div/>').html(error.Message).text());
            }

            vm.error = escapedError;
          } else {
            vm.error = 'Error making payment. Please try again.';
          }

          vm.processing = false;
        });
      }
    };

    this.cancel = function () {
      vm.dismiss({
        $event: 'cancel button'
      });
    };

    this.acceptedType = function (cardType) {
      if (cardType && vm.creditCard && vm.creditCard.hasOwnProperty('acceptedCCTypes') && vm.creditCard.acceptedCCTypes) {
        return vm.creditCard.acceptedCCTypes.indexOf(cardType) > -1;
      }
    };

    this.ccClassCheck = function (cardType, valid) {
      if (cardType && vm.creditCard.hasOwnProperty('cctype') && vm.creditCard.cctype) {
        if (vm.creditCard.cctype.substring(0, 1).toUpperCase() === cardType) {
          if (valid) {
            return 'lr-cc-icon--active-valid';
          } else {
            return 'lr-cc-icon--active';
          }
        } else {
          return 'lr-cc-icon--inactive';
        }
      }
    };

    this.getStates = function () {
      var defaultState = {
        ZZ: '--'
      };

      if (vm.billing && vm.billing.country && vm.states && vm.states.hasOwnProperty(vm.billing.country)) {
        vm.selectStates = vm.states[vm.billing.country];

        if (initialState) {
          vm.billing.state = initialState;
        } else {
          vm.billing.state = vm.selectStates[0];
        }
      } else {
        vm.selectStates = defaultState;
      }
    };

    this.setState = function () {
      vm.billing.state = vm.states[0];
    };

    this.hasStates = function () {
      return vm.selectStates && !vm.selectStates.hasOwnProperty('ZZ');
    };

    this.$onInit = function () {
      this.loading = false;
      this.processing = false;
      this.error = '';
      initialState = this.billing.state;
      PaymentService.getCountries().then(function (data) {
        vm.countries = data;
      });
      PaymentService.getStates().then(function (data) {
        vm.states = data;
        vm.getStates();
      });
      this.suggestedAmount = parseFloat(this.amount).toFixed(2) || 0;
      this.totalBalanceDue = parseFloat(this.balanceDue).toFixed(2) || 0; // check if full balance is due immediately

      try {
        var dueDate = Moment(vm.balanceDueDate).startOf('day');
        var today = Moment().startOf('day');
        vm.balanceDueRequired = dueDate.diff(today, 'days', true) <= 0 && parseFloat(vm.balanceDue).toFixed(2) > 0;

        if (vm.balanceDueRequired) {
          this.paymentAmount = this.totalBalanceDue;
        } else {
          if (this.suggestedAmount > 0) {
            this.paymentAmount = this.suggestedAmount;
            this.paymentSelection = 1;
          } else {
            this.paymentAmount = this.totalBalanceDue;
            this.paymentSelection = 2;
          }
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    };

    this.$onChanges = function (change) {//console.log('change', change);
    };
  }

  paymentModalCtrl.$inject = ['UtilsService', 'PaymentService', 'Moment', '$sce'];
  angular.module('payment-modal', []).component('paymentModal', {
    bindings: {
      admin: '@',
      transaction: '@',
      amount: '@',
      balanceDue: '@',
      balanceDueDate: '@',
      acceptedCardTypes: '@',
      billing: '<',
      creditCard: '<',
      currencySymbol: '@',
      close: '&',
      dismiss: '&'
    },
    controller: paymentModalCtrl,
    templateUrl: 'components/payment-modal/payment-modal.html'
  });
})();